"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCommand = void 0;
const clipanion_1 = require("clipanion");
/**
 * This command should be extended by **every** command in the monorepo.
 */
class BaseCommand extends clipanion_1.Command {
}
exports.BaseCommand = BaseCommand;
//# sourceMappingURL=index.js.map